import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import store from '../../store';
import CONFIG from "@/assets/js/config.js";

export default {
  name: "examDetail",
  components: {
    MainLayout,
    Loading
  },

  data() {
    return {
      isLoading: false,
      examInfo: {},
      academicYearArr: null,
      noDataMsg: CONFIG.NO_DATA_EXIST,
      examData: {},
      academicYear: '',
      subjectArr: [],
      examSubjects: [],
    };
  },

  methods: {
    getAcademicYear() {
      axios.get('getAcademicYear', {
        params: {
          campus_id: store.state.user.campus_id
        }
      })
        .then(res => {
          let $defaultSelectOption = [{
            'id': 0,
            'text': 'Select'
          }];
          this.academicYearArr = $defaultSelectOption.concat(res.data.academicYearArr);
        }).catch((error) => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },

    async getExamDetail() {
      try {
        this.isLoading = true;

        const response = await axios.get("/exam/detail", {
          params: {
            campus_id: store.state.user.campus_id,
            exam_id: this.$route.params.exam_id
          }
        });

        if (response.data[0] != undefined) {
          this.examInfo = response.data[0];
          const getSubjects = this.examInfo.subjects;
          this.examSubjects = this.examInfo.exam_subjects.map(examSubject => {
            return {
              name: getSubjects[getSubjects.findIndex(subject => subject.id == examSubject.subject_id)].subject_name,
              passMark: examSubject.pass_mark,
              distinctionMark: examSubject.distinction_mark
            }
          });
          this.examData = response.data;
          if (this.examInfo.subjects.length) {
            this.subjectArr = this.examInfo.subjects.map(subject => {
              return {
                id: subject.id,
                text: subject.subject_name,
              }
            });
          }
        }
        this.isLoading = false;
      } catch (error) {
        if (error.response && error.response.status == 401) {
          this.$store.commit('logout');
          window.location.replace('login');
        }
        console.error("Exam Detail API Error", error);
      } finally {
        this.isLoading = false;
      }
    },

    showList() {
      this.$router.push({
        path: "/exam/list"
      });
    },

    gradingDownload() {
      this.isLoading = true;
      axios.get(`/exam/gradingDownload/${this.$route.params.exam_id}`, {
        responseType: 'arraybuffer'
      })
        .then(response => {
          const fileURL = window.URL.createObjectURL(new Blob([response.data]));
          const fileLink = document.createElement('a');
          fileLink.href = fileURL;

          let examName = this.examInfo.exam_name || "exam_grading";
          examName = examName.normalize("NFC")
                             .trim()
                             .replace(/[^\p{L}\p{N}\p{M}]+/gu, "_")
                             .replace(/_+/g, "_")
                             .replace(/^_+|_+$/g, "");
          const date = new Date();
          const year = date.getFullYear();
          const month = String(date.getMonth() + 1).padStart(2, '0');
          const day = String(date.getDate()).padStart(2, '0');

          fileLink.setAttribute('download', `${examName}_${year}${month}${day}.xlsx`);
          document.body.appendChild(fileLink);
          fileLink.click();
          document.body.removeChild(fileLink);
          window.URL.revokeObjectURL(fileURL);

          this.isLoading = false;
        })
        .catch(error => {
          if (error.response && error.response.status === 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        });
    },
  },

  mounted() {
    this.isLoading = true;
    this.getAcademicYear();
    this.getExamDetail();
  },
};
